import { history } from "../../helpers/History";
import { ApplicationCloseReason } from "sdk/index";
import { StoreModel } from "../../models/Index";

export default function goBack(Store: StoreModel, event: any) {
    return Store.sdk
        .closeApp(ApplicationCloseReason.HomeButtonClick)
        .then((_: any) => {
            if (Store.common.hasMultiplyApplications) {
                return history.goBack();
            }

            history.push({ pathname: "/", search: history.location.search });
        });
}
